import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useAuthContext } from "src/contexts/AuthContext";
import { LoadingSpinner } from "src/components";
import { SpinnerContainer } from "src/pages/Allocations-V2/Tables/AllocationTableBody/AllocationTableBody.styles";
import { Box } from "@mui/material";

interface AuthProps {
  children: JSX.Element,
  redirectUrl?: string,
}

const withAdminAuthHandler = (WrappedComponent: any, redirectUrl = "/audience") => {

  const Wrapper: React.FC<AuthProps> = (props) => {
    const { user } = useAuthContext();
    let { children } = props;
    const router = useRouter();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      if(user) {
        if (!user.roles?.includes('Administrator')) {
          router.replace(redirectUrl);
        } else {
          setLoading(false)
        }
      }
    }, [user])


    if (loading) {
      return (
        <Box sx={{ height: "100vh" }}>
          <SpinnerContainer>
            <LoadingSpinner color="inherit"/>;
          </SpinnerContainer>
        </Box>
      )
    }

    return <WrappedComponent {...props} >{children}</WrappedComponent>;
  };

  return Wrapper;
};

export default withAdminAuthHandler;